import React from 'react';
import { Box, Typography } from '@mui/material';
import PropTypes from 'prop-types';

const TipBox = ({
  title = 'Tip:',
  children,
  content,
  sx = {},
  titleColor = '#0F172A',
  contentColor = '#383838',
  backgroundColor = '#F1F5FF',
  borderColor = '#BEDBFF',
  borderRadius = '4px',
  titleFontSize = '0.875rem',
  contentFontSize = '0.75rem',
  titleFontWeight = 700,
  contentFontWeight = 400,
  titleFontFamily = 'IBM Plex Sans, sans-serif',
  contentFontFamily = 'Inter, sans-serif',
  padding = 2,
  marginBottom = 3,
  ...props
}) => {
  const baseStyles = {
    p: typeof padding === 'object' ? padding : { xs: 1.5, sm: 2, md: padding },
    mb: typeof marginBottom === 'object' ? marginBottom : { xs: 2, sm: 3, md: marginBottom },
    borderRadius,
    backgroundColor,
    border: `1px solid ${borderColor}`,
  };

  const titleStyles = {
    fontFamily: titleFontFamily,
    fontSize: typeof titleFontSize === 'object' ? titleFontSize : { xs: '0.8125rem', sm: '0.875rem', md: titleFontSize },
    fontWeight: titleFontWeight,
    fontStyle: 'normal',
    lineHeight: '20px',
    letterSpacing: '-0.15px',
    color: titleColor,
    mb: { xs: 0.75, sm: 1, md: 1 },
  };

  const contentStyles = {
    fontFamily: contentFontFamily,
    fontSize: typeof contentFontSize === 'object' ? contentFontSize : { xs: '0.6875rem', sm: '0.75rem', md: contentFontSize },
    fontWeight: contentFontWeight,
    fontStyle: 'normal',
    lineHeight: 1.5,
    letterSpacing: '-0.15px',
    color: contentColor,
  };

  return (
    <Box
      sx={{
        ...baseStyles,
        ...sx,
      }}
      {...props}
    >
      <Typography sx={titleStyles}>{title}</Typography>
      {content ? (
        <Typography sx={contentStyles}>{content}</Typography>
      ) : (
        <Typography component="div" sx={contentStyles}>
          {children}
        </Typography>
      )}
    </Box>
  );
};

TipBox.propTypes = {
  title: PropTypes.string,
  children: PropTypes.node,
  content: PropTypes.string,
  sx: PropTypes.object,
  titleColor: PropTypes.string,
  contentColor: PropTypes.string,
  backgroundColor: PropTypes.string,
  borderColor: PropTypes.string,
  borderRadius: PropTypes.string,
  titleFontSize: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  contentFontSize: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  titleFontWeight: PropTypes.number,
  contentFontWeight: PropTypes.number,
  titleFontFamily: PropTypes.string,
  contentFontFamily: PropTypes.string,
  padding: PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.object]),
  marginBottom: PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.object]),
};

export default TipBox;

